module.exports = __webpack_public_path__ + "media/images/img_logo-color-0352e9c8f34bce79af683267c7d6ca05.png";